import React, { useCallback } from "react";
import { Helmet } from "react-helmet";
import "../../css/Home.css";
import Navbar from "../Navbar";
import Footer from "../Footer";
import ServiceNavigation from "./ServiceNavigation";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog"; 
import config from "../../../config";
import Services from "../../../ProviderServices.json";
import { Button } from "@mui/material";
import ThurentEventForm from "../ThurentEventForm";
import OfferingsSection from "./OfferingSection";
import { offeringsData } from './OfferingData';
import HeroSection from "./HeroSection";
import { HeroSectionData } from './HeroSectionData';
import { priestSeoDescriptions } from "./seoMappings";

function BookPriestService({ priestType = "default" }){
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get priest type from EITHER:
  // 1. prop (for clean URLs like /book-a-pandit-online)
  // 2. query parameter (for /service/hire-a-priest?type=satyanarayan)
  const params = new URLSearchParams(location.search);
  const queryPriestType = params.get("type");
  
  // Priority: Query param > Prop
  const finalPriestType = queryPriestType || priestType;
  
  // Get SEO data
  const seo = priestSeoDescriptions[finalPriestType] || priestSeoDescriptions.default;

  // Offerings Section
  const { heading, subHeading, list, image, ABOUT_SECTION_TITLE,
    ABOUT_SECTION_SUBTITLE, ABOUT_SECTION_DESC,alt } = offeringsData.bookPriest;

  const service = Services.find((service) =>
    location.pathname.includes(service.slug)
  );

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>        
        <meta name="description" content={seo.description} />
        <meta
          name="keywords"
          content="Book a pandit online
, pandit for griha pravesh
,online purohit services
,pandit for satyanarayan puja
,pandit for griha pravesh puja near me
,online pandit booking for temple-style rituals at home
,best pandit for housewarming ceremony
,online purohit services for home and office pujas
,book pandit online for satyanarayan puja at home
,trusted online pandit for all types of Hindu pujas
"  />
      </Helmet>

      <Navbar />
      <ServiceNavigation />
      <div className="th-service">
        <HeroSection
          service={service}
          providerListStorageKey={config.providerListStorageKey}
          data={HeroSectionData.bookPriest}
        />
        <div className="flex mt-5 justify-content-center lg:mt-0">
          <div
            className="event-form th-plan"
            style={{
              boxShadow: "none",
            }}
          >
            <ThurentEventForm />
          </div>
        </div>
      </div>
      <OfferingsSection
        heading={heading}
        subHeading={subHeading}
        offeringsList={list}
        image={image} 
        ABOUT_SECTION_TITLE={ABOUT_SECTION_TITLE}
        ABOUT_SECTION_SUBTITLE={ABOUT_SECTION_SUBTITLE}
        ABOUT_SECTION_DESC={ABOUT_SECTION_DESC}
        altdata ={alt}
      />   
      <ConfirmDialog />
      <Footer />
    </>
  );
}

export default BookPriestService;